export enum DataFieldTypes {
    number = 'number',
    date = 'date',
    boolean = 'boolean',
    dropdown = 'dropdown',
    longText = 'long-text',
    shortText = 'short-text',
}
